var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2557_8990)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 15,
    height: 15,
    rx: 3,
    fill: "#FFCB45"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8159 8.6C12.6838 8.6 12.5673 8.51359 12.5289 8.38719L11.787 5.94502C11.7009 5.66128 11.2991 5.66128 11.2129 5.94502L10.4711 8.38719C10.4327 8.51359 10.3162 8.6 10.1841 8.6H7.93688C7.64496 8.6 7.525 8.97463 7.76262 9.1442L9.60458 10.4586C9.70989 10.5338 9.75516 10.668 9.7169 10.7915L9.00022 13.1063C8.91391 13.385 9.23603 13.6104 9.46834 13.4338L11.3186 12.0274C11.4258 11.9459 11.5742 11.9458 11.6815 12.0272L13.5367 13.4352C13.7691 13.6115 14.0909 13.3861 14.0047 13.1075L13.2876 10.7914C13.2493 10.6679 13.2945 10.5338 13.3997 10.4586L15.2388 9.14407C15.4762 8.97439 15.3562 8.6 15.0644 8.6H12.8159Z",
    fill: "#F9FCFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2557_8990",
    x: 0,
    y: 0,
    width: 23,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2557_8990"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2557_8990",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingIcon);
export default __webpack_public_path__ + "static/media/RatingIcon.0057aa3511a5eb56efce434123677a0f.svg";
export { ForwardRef as ReactComponent };